module.exports = __webpack_public_path__ + "img/window-minimize.8ce71706.svg";